import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { ReleaseInfoComponent } from '@rxap/layout';
import { LanguageSelectorComponent } from '@rxap/ngx-material-localize';
import { LocalizationIconButtonComponent } from './shared/components/localization-selector/localization-icon-button/localization-icon-button.component';
import { PrivacyConsentIconButtonComponent } from './shared/privacy-consent/privacy-consent-icon-button/privacy-consent-icon-button.component';

@Component({
  imports: [
    RouterModule,
    ReleaseInfoComponent,
    MatIcon,
    MatMenu,
    LanguageSelectorComponent,
    MatIconButton,
    MatMenuTrigger,
    PrivacyConsentIconButtonComponent,
    LocalizationIconButtonComponent,
  ],
  standalone: true,
  selector: 'ed-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
